<ng-lottie
  [width]="'400'"
  height="400"
  [options]="options"
  (animationCreated)="animationCreated($event)">
</ng-lottie>
